import { UnaryOperation } from './unaryOperation';
export class SigmoidOperation extends UnaryOperation {
    constructor(tensorConstructor, dtype, allocator) {
        super(tensorConstructor, dtype, allocator);
    }
    operation(input) {
        return `1.0/(1.0 + exp(-${input}))`;
    }
}
//# sourceMappingURL=sigmoid.js.map